import createStore from 'unistore';
// import devtools from 'unistore/devtools';

import { initialState } from './actions';

export const store =
	/* process.env.NODE_ENV === 'production'
		? */ createStore(initialState);
// : devtools(createStore(initialState));

// export { actions } from './actions';
